import React, { useState } from "react";
import Pagination from "../components/pagination/pagination.component";

const usePaginate = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [currentLimit, setCurrentLimit] = useState(25);
  const [totalCount, setTotalCount] = useState(undefined);

  const handlePageLimit = (limit) => setCurrentLimit(limit);
  const handleSetPage = (page) => setCurrentPage(page);

  const paginationComponent = totalCount && (
    <Pagination
      totalItems={totalCount}
      currentPage={currentPage}
      setPage={handleSetPage}
      setPagePallete={handlePageLimit}
      defaultPagePallete={currentLimit}
      itemsPerPagePallet={[25, 50, 75, 100, 200, 500]}
      sliceData={3}
      searchBoxThreshold={5}
    />
  );

  return {
    setCurrentPage,
    setCurrentLimit,
    setTotalCount,
    paginationComponent,
    currentPage,
    currentLimit,
  };
};

export default usePaginate;
